/**
 * @deprecated Used only by migrated sf components. Use colors coming from our tailwind config.
 */
export const iconColors = {
  greenPrimary: 'green-primary',
  greenSecondary: 'green-secondary',
  black: 'black',
  darkSecondary: 'dark-secondary',
  grayPrimary: 'gray-primary',
  graySecondary: 'gray-secondary',
  lightPrimary: 'light-primary',
  white: 'white',
  redPrimary: 'red-primary',
  redSecondary: 'red-secondary',
  yellowPrimary: 'yellow-primary',
  yellowSecondary: 'yellow-secondary',
  bluePrimary: 'blue-primary',
  blueSecondary: 'blue-secondary',
};
/**
 * @deprecated Used only by migrated sf components. Use colors coming from our tailwind config.
 */
export const colors = {
  primary: 'color-primary',
  secondary: 'color-secondary',
  light: 'color-light',
  dark: 'color-dark',
  info: 'color-info',
  success: 'color-success',
  warning: 'color-warning',
  danger: 'color-danger',
};
/**
 * @deprecated Used only by migrated sf components. Use colors coming from our tailwind config.
 */
export const colorsValues = Object.values(colors);
/**
 * @deprecated Used only by migrated sf components. Use colors coming from our tailwind config.
 */
export const iconColorsValues = Object.values(iconColors);
/**
 * @deprecated Used only by migrated sf components. Use colors coming from our tailwind config.
 */
export default colors;
